import {
  Directive,
  ElementRef,
  EventEmitter,
  HostBinding,
  Input,
  Output,
} from '@angular/core';

export interface FullscreenTransition {
  isFullscreen: boolean;
  element: HTMLElement | null;
}

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[fullscreen]',
  exportAs: 'fullscreen',
})
export class FullscreenDirective {
  private element: HTMLElement;
  private isFullscreenMode = false;

  @Input()
  set fullscreen(value: HTMLElement | ElementRef | '' | undefined) {
    this.element =
      value instanceof ElementRef
        ? value.nativeElement
        : value instanceof HTMLElement
        ? value
        : this.hostElement.nativeElement;
  }

  @HostBinding('class.fullscreen')
  get isFullscreen(): boolean {
    return this.isFullscreenMode;
  }

  @Output()
  fullScreenChange = new EventEmitter<FullscreenTransition>();

  constructor(private hostElement: ElementRef<HTMLElement>) {
    this.element = this.hostElement.nativeElement;
  }

  enter(): void {
    if (!this.isFullscreenMode) {
      this.element.style.position = 'fixed';
      this.element.style.top = '0';
      this.element.style.left = '0';
      this.element.style.width = '100%';
      this.element.style.height = '100%';
      this.element.style.zIndex = '1000';
      this.isFullscreenMode = true;
      this.emitFullscreenChange();
    }
  }

  exit(): void {
    if (this.isFullscreenMode) {
      this.element.style.position = '';
      this.element.style.top = '';
      this.element.style.left = '';
      this.element.style.width = '';
      this.element.style.height = '';
      this.element.style.zIndex = '';
      this.isFullscreenMode = false;
      this.emitFullscreenChange();
    }
  }

  toggle(): void {
    this.isFullscreenMode ? this.exit() : this.enter();
  }

  private emitFullscreenChange(): void {
    this.fullScreenChange.emit({
      isFullscreen: this.isFullscreenMode,
      element: this.isFullscreenMode ? this.element : null,
    });
  }
}
